"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports.CustomPrevButton = exports.CustomNextButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _feather = require("styled-icons/feather");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-radius: 50%;\n  height: 4rem;\n  width: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  box-shadow: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  & .slick-next::before {\n    content: none;\n  }\n  & .slick-prev::before {\n    content: none;\n  }\n  & .slick-prev {\n    left: -10px;\n    z-index: 100;\n    opacity: .5;\n  }\n  & .slick-next {\n    right: 10px;\n    z-index: 100;\n    opacity: .5;\n  }\n  & .slick-prev:hover {\n    opacity: 1;\n  }\n  & .slick-next:hover {\n    opacity: 1;\n  }\n  & .slick-disabled {\n    display: none;\n  }\n  @media (max-width: 1399px) {\n    & .slick-prev {\n      left: 5px;\n      z-index: 100;\n    }\n    & .slick-next {\n      right: 15px;\n      z-index: 100;\n    }\n  }\n  ", "\n  & :active {\n    transform: scale(0.95);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var CustomButtonContainer = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.vertical && {
    "&.slick-prev": {
      top: "0rem",
      zIndex: "20",
      position: "relative",
      left: "45%",
      transform: "translate(-50%, 0) rotate(90deg)",
      height: "auto",
      width: "1rem"
    },
    "&.slick-next": {
      top: "0rem",
      zIndex: "20",
      position: "relative",
      left: "45%",
      transform: "translate(-50%, 0) rotate(90deg)",
      height: "auto",
      width: "1rem"
    }
  };
});

var CustomButtonStyle = _styledComponents["default"].div(_templateObject2(), function (props) {
  return !props.disabled ? '#fff' : 'transparent';
}, function (props) {
  return !props.disabled && "0px 3px 10px rgba(0, 0, 0, .1)";
});

var CustomNextButton = function CustomNextButton(props) {
  var direction = props.direction,
      onClick = props.onClick,
      style = props.style,
      className = props.className,
      classes = props.classes,
      _props$vertical = props.vertical,
      vertical = _props$vertical === void 0 ? false : _props$vertical,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  return /*#__PURE__*/_react["default"].createElement(CustomButtonContainer, {
    vertical: vertical,
    onClick: disabled ? function () {} : onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    style: {
      style: style
    }
  }, /*#__PURE__*/_react["default"].createElement(CustomButtonStyle, {
    onClick: disabled ? function () {} : onClick,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_feather.ArrowRight, {
    color: disabled ? "#D0D0D0" : "#C2171D",
    size: "20px"
  }))));
};

exports.CustomNextButton = CustomNextButton;

var CustomPrevButton = function CustomPrevButton(props) {
  var direction = props.direction,
      onClick = props.onClick,
      style = props.style,
      className = props.className,
      classes = props.classes,
      _props$vertical2 = props.vertical,
      vertical = _props$vertical2 === void 0 ? false : _props$vertical2,
      _props$disabled2 = props.disabled,
      disabled = _props$disabled2 === void 0 ? false : _props$disabled2;
  return /*#__PURE__*/_react["default"].createElement(CustomButtonContainer, {
    vertical: vertical,
    onClick: disabled ? function () {} : onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    style: {
      style: style
    }
  }, /*#__PURE__*/_react["default"].createElement(CustomButtonStyle, {
    onClick: disabled ? function () {} : onClick,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_feather.ArrowLeft, {
    color: disabled ? "#D0D0D0" : "#C2171D",
    size: "20px"
  }))));
};

exports.CustomPrevButton = CustomPrevButton;